import { validateAmount } from '@betty/moonlight';

const PHONE_PATTERN = /^\d{10}$/;
const EMAIL_PATTERN =
  /^[a-zA-Z0-9][a-z0-9-_.+]*@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/;

export const getPhoneError = (phone: string) =>
  PHONE_PATTERN.test(phone) ? undefined : 'interacInvalidPhone';

export const getAmountError = (
  amount: string,
  minAmount?: number,
  maxAmount?: number,
) => {
  if (!validateAmount(amount)) {
    return 'interacInvalidAmount';
  }

  if (minAmount !== undefined && Number(amount) < minAmount) {
    return 'interacAmountLessThanMin';
  }

  if (maxAmount !== undefined && Number(amount) > maxAmount) {
    return 'interacAmountGreaterThanMax';
  }
};

export const getEmailError = (email: string) =>
  EMAIL_PATTERN.test(email.toLocaleLowerCase())
    ? undefined
    : 'interacInvalidEmail';
